export default __webpack_public_path__ + "static/media/heart-icon.b74c90f2.svg";